import React, { useState, useEffect } from 'react';
import './Style/AllUsers.css'; // Create this CSS file
import useUsersData from './../Auth/AllUsers';
import TopNavbar from '../home/TopNavbar';
import Loading from '../home/Loading';

const AllUsers = () => {
    const { users, loading } = useUsersData();

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="all-user-data-container">
            <div className="user-data-content-wrapper">
                <TopNavbar name="All Users Data" />

                <div className="user-data-card">
                    <h2 className="user-data-title">All Users Information</h2>
                    
                    <div className="table-responsive">
                        <table className="user-data-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Class</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Register Date</th>
                                    <th>Last Login</th>
                                    <th>User ID</th>
                                    <th>First Login ID</th>
                                    <th>Second Login ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users && users.length > 0 ? (
                                    users.map((user, index) => (
                                        <tr key={user.id || index}>
                                            <td>{index + 1}</td>
                                            <td>{user.name || 'N/A'}</td>
                                            <td>{user.class || 'N/A'}</td>
                                            <td>{user.phone || 'N/A'}</td>
                                            <td>{user.email || 'N/A'}</td>
                                            <td>{user.registar_date || 'N/A'}</td>
                                            <td>{user.last_login || 'N/A'}</td>
                                            <td>{user.id || 'N/A'}</td>
                                            <td>{user.first_login_id || 'N/A'}</td>
                                            <td>{user.second_login_id || 'N/A'}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="no-data-message">
                                            No users found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="user-data-stats">
                        <p>Total Users: <strong>{users ? users.length : 0}</strong></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllUsers;